import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import SideBar from "../../components/cases/Sidebar";
import CasesSideBar from "../../common/sidebar/CasesSideBar";
import { getConsultantsList } from "../../services/cases";
import { getUserIdFromLocalStorage } from "../../utils/Utilities";
import { getAdvisorAppointments } from "../../services/appointment";
import { useDispatch, useSelector } from "react-redux";
import {
  setLoadingStateDisable,
  setLoadingStateEnable,
} from "../../redux/slices/CasesSlice";

const AppointmentEC = () => {
  const location = useLocation();
  const { id } = useParams();
  const disptch = useDispatch();
  const userInformation = useSelector((state) => state.user);
  const [consultantsList, setConsultantsList] = useState([]);
  const [selectedConsultant, setSelectedConsultant] = useState(null);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState("");
  const [searchFilterState, setSearchFilterState] = useState(false);
  const [entireCasesText, setEntireCasesText] = useState(false);
  let uID = getUserIdFromLocalStorage();
  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };
  async function fetchData() {
    disptch(setLoadingStateEnable());

    try {
      const result = await getAdvisorAppointments(
        selectedConsultant !== null ? selectedConsultant : uID,
        search
      );
      if (result?.success) {
        setData(result?.payLoad?.length > 0 ? result.payLoad : []);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setSearchFilterState(false);
      disptch(setLoadingStateDisable());
    }
  }
  async function fetchConsultantsList() {
    const result = await getConsultantsList(
      userInformation.role?.roleName,
      userInformation.branchInfo?.bankId,
      userInformation.branchInfo?.branchId
    );
    if (result?.success && result?.payLoad?.items?.length) {
      setConsultantsList(
        result.payLoad.items.map((item) => ({
          name: item.firstName + " " + item.lastName,
          id: item.id,
        }))
      );
    }
  }
  useEffect(() => {
    fetchData();
  }, [refresh]);
  useEffect(() => {
    if (userInformation.branchInfo !== null) {
      fetchConsultantsList();
    }
  }, [userInformation.branchInfo]);
  const handleSearch = (query) => {
    setSearch(query);
  };
  const handleFilterStateActive = () => {
    setSearchFilterState(true);
    setEntireCasesText(true);
  };
  const handleEntireCasesText = () => {
    setEntireCasesText(false);
  };
  const handleSetConsultantFilter = (value = null) => {
    setSelectedConsultant(value);
    handleFilterStateActive();
    if (value === null) handleEntireCasesText();
  };
  return (
    <>
      <Box className="family-tree-main-container">
        <Grid container spacing={5} className="balance-of-assets">
          <Grid item xl={1} lg={1} sm={12} xs={12} />
          <Grid item xl={2} lg={2} sm={12} xs={12}>
            {id ? <CasesSideBar id={id} /> : null}
          </Grid>
          <Grid
            item
            xl={9}
            lg={9}
            sm={12}
            xs={12}
            style={{ minHeight: "calc(100vh - 72px)" }}
          >
            <Outlet
              context={[
                data,
                handleRefresh,
                location,
                search,
                handleSearch,
                searchFilterState,
                handleFilterStateActive,
                entireCasesText,
                handleEntireCasesText,
                handleSetConsultantFilter,
                selectedConsultant,
                consultantsList,
              ]}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default AppointmentEC;
